import axios from "axios";

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://65.1.0.71:8086";
const API_BASE_URL = window.env.API_BASE_URL;

// Login API
export const login = async (credentials) => {
    const response = await axios.post(`${API_BASE_URL}/login`, credentials);

    if (response.data) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("privileges", JSON.stringify(response.data.privileges));
    }

    return response;
};

export const getMultipleShipment = async (token) => {

    try {
        const response = await axios.post(`${API_BASE_URL}/api/tracking/shipment/`,
            { "ids": [9, 42] },
            {
                headers: { Authorization: `Bearer ${token}` }
            });
        console.log(response.data);

        return response.data;
    }
    catch (error) {
        console.log("Error while getting Device Informations " + error);

    }
}

// Fetch GPS Data by Shipment ID
export const getGPSData = async (token, shipmentId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/shipment/${shipmentId}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data; // Return GPS data
    } catch (error) {
        console.error("Error fetching GPS data:", error);
        return null; // Return null if an error occurs
    }
};


// Fetch Shipments API
export const getShipments = async (token) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/api/dash/shipment/`,
            { status: "STARTED" },
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching shipments:", error);
        return [];
    }
};

export const getAllDeviceInfo = async (token) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/api/dash/devices`,
            {},
            { headers: { Authorization: `Bearer ${token}` } }
        );

        console.log("All Devices:", JSON.stringify(response.data, null, 2));
        return response.data;
    } catch (error) {
        console.error("Error while fetching all the devices:", error);
        return [];
    }
};

export const getGeoFence = async (token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/geofence/1`,
            {
                headers:
                {
                    Authorization: `Bearer ${token}`
                }
            }
        );
        console.log("Fetched Geofence: " + JSON.stringify(response.data, null, 2));
        return response.data;

    } catch (error) {
        console.log("Unable to fetch Geofence: " + error);
        return;
    }
}

export const getDeviceInfo = async (token, id) => {
    try {
        const toTime = new Date();

        const fromTime = new Date(toTime);
        fromTime.setHours(fromTime.getHours() - 5);

        const formatISO = (date) => date.toISOString();

        const response = await axios.post(
            `${API_BASE_URL}/api/tracking/journey/data/${id}`,
            {
                "from": formatISO(fromTime),
                "to": formatISO(toTime)
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        );
        const lastDeviceInfo = response.data.data?.[response.data.data.length - 1] || null;
        console.log("Last Device Info:", JSON.stringify(lastDeviceInfo, null, 2));

        // console.log("Current device info: " + JSON.stringify(response.data[response.data.length - 1] , null, 2));

        // return response.data[response.data.length - 1];
        return lastDeviceInfo;
    } catch (error) {
        console.log("Error while fetching device info: " + error);
        return null;
    }
};

export const getProfileInfo = async (token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/self/`, {
            headers: { Authorization: `Bearer ${token}` }
        });

        console.log("Profile Info:", JSON.stringify(response.data));
        return response.data;
    } catch (error) {
        console.error("Error while fetching profile info:", error);
        return [];
    }
};
